import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSearchParams } from 'react-router-dom';
import { getTrending, getImageUrl } from '../services/api';
import ContentCard from '../components/ContentCard';

const HomeContainer = styled.div`
`;

const Hero = styled.div`
  height: 80vh;
  position: relative;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.8)),
    url(${props => props.background}) center/cover no-repeat;
  display: flex;
  align-items: flex-end;
  padding: 0 60px 60px;
`;

const HeroContent = styled.div`
  max-width: 600px;
`;

const HeroTitle = styled.h1`
  font-size: 3rem;
  margin-bottom: 1rem;
`;

const HeroDescription = styled.p`
  font-size: 1.2rem;
  margin-bottom: 2rem;
  color: #e5e5e5;
`;

const ContentSection = styled.section`
  padding: 40px 60px;
`;

const SectionTitle = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 20px;
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
`;

const Home = () => {
  const [searchParams] = useSearchParams();
  const [trending, setTrending] = useState([]);
  const [heroContent, setHeroContent] = useState(null);
  const category = searchParams.get('category') || 'all';

  useEffect(() => {
    const fetchTrending = async () => {
      try {
        const mediaType = category === 'movies' ? 'movie' : 
                         category === 'series' ? 'tv' : 'all';
        
        const data = await getTrending(mediaType);
        setTrending(data.results);
        if (data.results.length > 0) {
          setHeroContent(data.results[0]);
        }
      } catch (error) {
        console.error('Error fetching trending content:', error);
      }
    };

    fetchTrending();
  }, [category]);

  return (
    <HomeContainer>
      {heroContent && (
        <Hero background={getImageUrl(heroContent.backdrop_path, 'original')}>
          <HeroContent>
            <HeroTitle>
              {heroContent.title || heroContent.name}
            </HeroTitle>
            <HeroDescription>
              {heroContent.overview}
            </HeroDescription>
          </HeroContent>
        </Hero>
      )}

      <ContentSection>
        <SectionTitle>
          {category === 'all' ? 'Trending Now' : 
           category === 'movies' ? 'Trending Movies' : 'Trending TV Shows'}
        </SectionTitle>
        <ContentGrid>
          {trending.map(item => (
            <ContentCard
              key={item.id}
              id={item.id}
              title={item.title || item.name}
              poster={getImageUrl(item.poster_path, 'w500')}
              type={item.media_type || (category === 'movies' ? 'movie' : 'tv')}
            />
          ))}
        </ContentGrid>
      </ContentSection>
    </HomeContainer>
  );
};

export default Home; 